import { render, staticRenderFns } from "./SpacesEditorToolbarOverflowList.vue?vue&type=template&id=f6f5d266&scoped=true"
import script from "./SpacesEditorToolbarOverflowList.js?vue&type=script&lang=js&external"
export * from "./SpacesEditorToolbarOverflowList.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditorToolbarOverflowList.scss?vue&type=style&index=0&id=f6f5d266&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f5d266",
  null
  
)

export default component.exports